document.addEventListener('DOMContentLoaded', function() {
  function updatePromoTimers() {
    const timers = document.querySelectorAll('.js-promo-timer');
    if (timers.length === 0) return;

    const now = new Date().getTime();
    
    timers.forEach(timer => {
      const endTimeStr = timer.getAttribute('data-end-time');
      if (!endTimeStr) return;
      
      const endDate = new Date(endTimeStr).getTime();
      if (isNaN(endDate)) return;
      
      const distance = endDate - now;
      const display = timer.querySelector('.js-timer-display');
      
      if (distance < 0) {
        timer.style.display = 'none';
        if (display) display.innerHTML = "00 : 00 : 00";
      } else {
        const totalHours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);
        
        let timeString = (totalHours < 10 ? "0" + totalHours : totalHours) + " : " + 
                         (minutes < 10 ? "0" + minutes : minutes) + " : " + 
                         (seconds < 10 ? "0" + seconds : seconds);
                      
        if (display) display.innerHTML = timeString;
        timer.style.display = ''; 
      }
    });
  }

  updatePromoTimers(); 
  setInterval(updatePromoTimers, 1000);
});
